<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Bachelor of Business Administration (Computer Application)</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="index.php">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Bachelor of Business Administration (Computer Application)</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="department-tab" data-bs-toggle="tab" data-bs-target="#department"
              type="button" role="tab" aria-controls="department" aria-selected="true">About Department</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="opportunities-tab" data-bs-toggle="tab" data-bs-target="#opportunities"
              type="button" role="tab" aria-controls="opportunities" aria-selected="false">Opportunities which await
              you</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="department" role="tabpanel" aria-labelledby="department-tab">
            <div>
              <p>Bachelor of Computer Application is the acronym for Bachelor of Business Administration (Computer
                Application). It is an undergraduate course. You can pursue it past Class 12th. It is a three year
                course. If you intend to explore into the innovative yet promising world of computer languages, this one
                is for you. The course has been witnessed by the Masters of the industry, as an entry ticket to initiate
                the journey in Information Technology. Undoubtedly, it serves to set an academic base worthy for a
                sophisticated career in Computer Applications.</p>
            </div>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <ul class="list-before">
              <li>A candidate is eligible for admission to the Degree in Bachelor of Business Administration –Computer
                Application after passing 12th Std. examination (H.S.C. 10 +2) from any stream with English as passing
                subject and has secured 40% marks at 12th std.</li>
              <li>Three Years Diploma after S.S.C. i.e. 10th Standard of Board of Technical Education conducted by
                Government of Maharashtra or its equivalent.</li>
              <li>Two Years Diploma in Pharmacy after H.S.C., of Board of Technical Education conducted by Government of
                Maharashtra or its equivalent.</li>
              <li>MCVC</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">3 years/6 semesters</h4>
            <ul class="list-before mt-3">
              <li><strong>Course curriculum:-</strong> the course lays emphasis on C, C++, HTML, PHP, and Java and web
                application development. It also involves web technology, architecture of computers and knowledge
                pertaining to operating systems. Ample opportunity for practical is provided to the students in order to
                gain first-hand experience.</li>
              <li><strong>Avenues to explore after Bachelor of Business Administration (Computer Application):-</strong>
                A plethora of jobs in the Private and Government organization can be explored post a degree of Bachelor
                in Computer Application. The degree holders can go for jobs in the educational sector as well.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="opportunities" role="tabpanel" aria-labelledby="opportunities-tab">
            <p>IT industry is a rapidly growing industry. It is for the students to decide on the prospect they choose
              for themselves:-</p>
            <ul class="list-before">
              <li><strong>Placement-</strong> avail placement in Private or Government organization with a completed
                Bachelor of Business Administration (Computer Application) degree. System Engineer, junior programmer,
                software tester, software developer, web developer, system administrator in a private enterprise after
                the completion of the course. </li>
              <li><strong>MBA-</strong> you need to prepare for CAT to get admission to an MBA program, which becomes
                comparatively seamless with a Bachelor of Business Administration (Computer Application) degree in hand.
              </li>
              <li><strong>MCA-</strong> you can pursue a Masters in Computer application for higher studies after
                Bachelor in the subject.</li>
              <li><strong>M.Sc CS/IT-</strong> Join the Postgraduate program of Computer Science or Information
                Technology to widen your horizon.</li>
              <li><strong>Teacher-</strong> Take a job in the teaching industry with the degree and practical experience
                learnt through Bachelor of Business Administration (Computer Application).</li>
              <li><strong> MS abroad- </strong>Post completion of the Bachelor of Business Administration (Computer
                Application) degree you can pursue MS for availing more opportunities and better jobs.</li>
            </ul>
          </div>
        </div>
        <div class="text-center">
          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button">Apply Now</a>
        </div>
      </div>
    </div>
  </div>
</section>
